/*
 * @Author: qinzhang14
 * @Date: 2021-11-29 10:23:56
 * @LastEditTime: 2021-11-29 15:10:23
 * @LastEditors: qinzhang14
 * @Description: 
 * @FilePath: \teaching-web\src\services\user.js
 */
import { axiosFactory } from './axios-factory'
export default {
    // 获取登录人信息
    getUserName: (params) => axiosFactory({
        url: 'user/getUserName',
        params,
    }),
}
